// Step 23 — contract identity card.
//
// Reads only fields the backend already returns (`title`, `kind`,
// `source`, `acquirer_name`, `acquirer_id`, `seed_template_kind`,
// `seed_template_id`, `proposed_by_id`). Missing fields simply don't
// render — no invented parties, no fabricated seed templates.

import { AISection } from "../AIPrimitives";
import { contractKindLabel } from "./helpers";

const SOURCE_LABEL = {
  ai: "AI-genererad",
  human: "Manuellt skapad",
};

export default function AIContractIdentityCard({ detail }) {
  if (!detail) return null;

  const rows = [];
  rows.push(["Typ", contractKindLabel(detail.kind)]);
  if (detail.source) {
    rows.push(["Källa", SOURCE_LABEL[detail.source] || detail.source]);
  }
  if (detail.acquirer_name) {
    rows.push(["Köpare", detail.acquirer_name]);
  } else if (detail.acquirer_id) {
    rows.push(["Köpare", `#${detail.acquirer_id}`]);
  }
  if (detail.contact_id != null) {
    rows.push(["Kontakt (signer)", `#${detail.contact_id}`]);
  }
  if (detail.seed_template_kind) {
    const seedBits = [detail.seed_template_kind];
    if (detail.seed_template_id) {
      seedBits.push(`#${detail.seed_template_id}`);
    }
    rows.push(["Seed-mall", seedBits.join(" · ")]);
  }
  if (detail.deal_action_id != null) {
    rows.push(["Kopplad åtgärd", `Action #${detail.deal_action_id}`]);
  }

  return (
    <AISection title="Identitet">
      <div className="qai-contract-identity">
        <div className="qai-contract-identity-name">{detail.title}</div>
        <dl className="qai-contract-identity-facts">
          {rows.map(([k, v]) => (
            <div key={k} className="qai-contract-identity-row">
              <dt>{k}</dt>
              <dd>{v}</dd>
            </div>
          ))}
        </dl>
      </div>
    </AISection>
  );
}
